(function ($) {
    $('.offer-30-subscription .offer-30-subscription__select.variant li').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        const variant_id = $(this).data('variant');
        const show_price_per_month = $(this).parents('.offer-30').data('show-prices-per-month');
        const variant_length = (show_price_per_month) ? $(this).data('variant-length') : 1;
        const variant_show_price_day = $(this).data('variant-show-price-day');
        const variant_price_for_day = $(this).data('variant-price-for-day');
        const show_promo_prices = $(this).parents('.offer-30').data('show-promo-prices');
        const cart_url = $(this).parents('.offer-30').data('cart-url');

        $('.offer-30_column').each(function () {

            const variants = $(this).data('variants')
            const $price_package = $(this).find('.prices .price_package .price');
            const $price_month = $(this).find('.prices .price-month strong');
            const $price_month_del = $(this).find('.prices .price-month del');
            const $price_day = $(this).find('.price_package .price_for_day');

            if ( ( !show_promo_prices && parseInt(variant_length) !== 1 ) || (show_promo_prices && variants[variant_id]['is_on_sale'] ) ) {
                $price_month_del.show();
            } else {
                $price_month_del.hide();
            }

            if(variant_show_price_day) {
                $price_day.show();
            } else {
                $price_day.hide();
            }

            const currency_symbol = $(this).find('.price_for_day .woocommerce-Price-currencySymbol').clone();
            $(this).find('.price_for_day span.woocommerce-Price-amount.amount').text(formatPrice(variant_price_for_day) + ' ').append(currency_symbol);

            let price_per_month = Math.round(variants[variant_id]['price'] / variant_length);
            let base_price_per_month = (!show_promo_prices) ? Math.round(variants[0]['price'] / variant_length) : Math.round(variants[variant_id]['display_regular_price'] / variant_length);

            $price_month.text(price_per_month);
            $price_package.html(variants[variant_id]['price_html']);
            $price_month_del.text(base_price_per_month);

            const $add_to_cart = $(this).find('.product a');
            const $gtm4wp_data = $(this).find('.gtm4wp_productdata')
            const variants_gtm4wp_data = $(this).data('gtm4wp-data');

            const $properties = $(this).find('.property');

            $properties.each(function () {
                if (!$(this).data('showOn').includes(variant_id.toString())) {
                    $(this).addClass('hidden');
                } else {
                    $(this).removeClass('hidden');
                }
            });

            const $omnibus = $(this).find('.omnibus');
            $omnibus.html(variants[variant_id]['omnibus_msg']);

            $add_to_cart.attr('href', `${cart_url}?add-to-cart=` + variants[variant_id]['variation_id']);
            $add_to_cart.attr('data-product_id', variants[variant_id]['variation_id'])
            $gtm4wp_data.attr('data-gtm4wp_product_data', variants_gtm4wp_data[variant_id]);
        });

        const $package_info = $('.package-info');
        if ($package_info.length > 0) {
            const package_description = $package_info.data('descriptions')[variant_id];
            $package_info.html(package_description);
        }
    });

    function formatPrice(price) {
        price = (Number.isInteger(price)) ? price : price.toFixed(2);
        return price.toString().replace('.', ',');
    }

    $('body').on('click', function (e) {
        if ($(e.target).parents().hasClass('property')
            || $(e.target).hasClass('property')
            || $(e.target).parents().hasClass('property_group')
            || $(e.target).hasClass('property_group')) {
            e.stopPropagation();
            return;
        }
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
    });

    $('.expand-button').on('click', function(){
        $('.offer-30-packages-comparison').removeClass('collapsed');
    });

    $(document).on("keydown", (event) => {
        if (event.key === "Escape" || event.keyCode === 27) {
            closeModal();
        }
    });

    $('#offer-30-video-modal .modal-close').on('click', closeModal);

    $('#offer-30-video-modal .modal-wrapper').on('click', () => {
        closeModal();
    });

    $('#offer-30-video-modal .modal').on('click', (e) => {
        e.stopPropagation();
    });

    function closeModal() {
        $('#offer-30-video-modal video')[0]?.pause();
        $('#offer-30-video-modal').fadeOut(300);
        $('body').css('overflow', 'auto');
    }

    $('.offer-30-subscription .property, .offer-30-subscription .property-group-heading').on('click', function (e){
        openTooltip($(this).find('.tooltip'), e);
    });

    if(window.innerWidth > 992){
        $('.offer-30-subscription .property, .offer-30-subscription .property-group-heading').on('mouseover', function (e){
            openTooltip($(this).find('.tooltip'), e);
        });
    }

    $('.offer-30-subscription .property, .offer-30-subscription .property-group-heading').on('mouseout', function (event){
        var e = event.toElement || event.relatedTarget;
        if ($(e).hasClass('tooltip-open') || $(e).parents().hasClass('tooltip-open') ) {
            return;
        }

        $('.tooltip').removeClass('open')
        $('.tooltip-open').remove();
    });


    function openTooltip($tt, event) {
        if(event.type === 'click' && $(event.target).hasClass('play-icon') && $tt.hasClass('open')) {
            $('.tooltip-video').trigger('click');
            return;
        }

        if($tt.hasClass('open')) return;
        $('.tooltip-open').remove();
        $('.tooltip').removeClass('open');
        $tt.addClass('open');

        const ID = $tt.parent().data('id');
        const tooltip_content = $tt.data('tooltip-content');
        const tooltip_video = $tt.data('video');
        const $tooltip = $(`${tooltip_content}`);
        $tt.append($tooltip);
        $tooltip.attr('data-id', ID);


        let offset = $tooltip.offset();
        if (offset) {
            $tooltip.appendTo("body")
                .css({
                    position: "absolute",
                    top: offset.top,
                    left: offset.left,
                    translate: 'unset',
                });
        }

        $tooltip.find('.tooltip-video').on('click', function (){
            $('#offer-30-video-modal video').attr('src', tooltip_video).attr('controls', 'controls');
            $('#offer-30-video-modal video')[0].play();
            $('#offer-30-video-modal').fadeIn(300);
            $('body').css('overflow', 'hidden');
            $('.tooltip-open').remove();
            $tt.removeClass('open');
        });
    }

})(jQuery);